import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toastError, toastSuccess } from "../../../Toast/Toast";
import { BaseUrl } from "../../../BaseUrl";


// insert / update
export const POST_M_User_InsertAPI = createAsyncThunk("POST_M_User_Insert", async ({ data }) => {
    const {
        UserID,
        UserName,
        Password,
        FirstName,
        LastName,
        EmailID,
        ContactNumber,
        token,
        handleIsPost,
        setloader,
        ScreenType,
    } = data

    var myHeaders = new Headers();
    if (token) {
        myHeaders.append("Authorization", "Bearer " + token);
    }

    var formdata = new FormData();

    if (ScreenType === "Update") {
        formdata.append("UserID", UserID);
    }
    formdata.append("UserName", UserName);
    formdata.append("Password", Password);
    formdata.append("FirstName", FirstName);
    formdata.append("LastName", LastName);
    formdata.append("EmailID", EmailID);
    formdata.append("ContactNumber", ContactNumber);

    const requestOptions = {
        method: ScreenType === "Update" ? "PATCH" : "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
    };

    const url =
        ScreenType === "Update"
            ? `${BaseUrl}/Master/M_User_Update`
            : `${BaseUrl}/Master/POST_M_User_Insert`;

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                toastSuccess(result?.message)
                handleIsPost && handleIsPost(result.message)
            } else {
                toastError(result?.message)
            }
            setloader && setloader(false)
            return result
        })
        .catch((error) => {
            toastError("Something went wrong")
            setloader && setloader(false)
            throw error // keeps the thunk in the `rejected` case
        })
})

const POST_M_User_InsertSlice = createSlice({
    name: "POST_M_User_Insert",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(POST_M_User_InsertAPI.pending, (state) => {
            state.isPostLoading = true;
            state.isError = false;
        });
        builder.addCase(POST_M_User_InsertAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.isError = false;
            state.PostData = action.payload;
        });
        builder.addCase(POST_M_User_InsertAPI.rejected, (state, action) => {
            console.log("Error", action.error?.message);
            state.isPostLoading = false;
            state.isError = true;
            state.PostData = null;
        });
    },
})

export const POST_M_User_InsertReducer = POST_M_User_InsertSlice.reducer


// delete
export const M_User_DeleteAPI = createAsyncThunk("M_User_Delete", async ({ data }) => {
    const {
        UserID,
        token,
        handleIsPost,
        setloader,
    } = data

    var myHeaders = new Headers();
    if (token) {
        myHeaders.append("Authorization", "Bearer " + token);
    }

    var formdata = new FormData();
    formdata.append("UserID", UserID);

    const requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
    };

    const url = `${BaseUrl}/Master/M_User_Delete`

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                toastSuccess(result?.message)
                handleIsPost && handleIsPost(result.message)
            } else {
                toastError(result?.message)
            }
            setloader && setloader(false)
            return result
        })
        .catch((error) => {
            toastError("Something went wrong")
            setloader && setloader(false)
            throw error
        })
})

const M_User_DeleteSlice = createSlice({
    name: "M_User_Delete",
    initialState: {
        isDeleteLoading: false,
        DeleteData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(M_User_DeleteAPI.pending, (state) => {
            state.isDeleteLoading = true;
            state.isError = false;
        });
        builder.addCase(M_User_DeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.isError = false;
            state.DeleteData = action.payload;
        });
        builder.addCase(M_User_DeleteAPI.rejected, (state, action) => {
            console.log("Error", action.error?.message);
            state.isDeleteLoading = false;
            state.isError = true;
            state.DeleteData = null;
        });
    },
})

export const M_User_DeleteReducer = M_User_DeleteSlice.reducer


// get data
export const GET_M_User_SelectAPI = createAsyncThunk("GET_M_User_Select", async ({ data }) => {
    const {
        UserID,
        SearchTerm,
        token,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    if (token) {
        myHeaders.append("Authorization", "Bearer " + token);
    }

    var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
    };

    const url = `${BaseUrl}/Master/Get_M_User_Select?UserID=${UserID ?? 0}&SearchTerm=${encodeURIComponent(SearchTerm ?? "")}`

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data && result?.data?.table) {
                return result.data.table
            } else {
                return result
            }
        })
})

const GET_M_User_SelectSlice = createSlice({
    name: "GET_M_User_Select",
    initialState: {
        isLoading: false,
        TableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(GET_M_User_SelectAPI.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(GET_M_User_SelectAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.isError = false;
            state.TableData = action.payload;
        });
        builder.addCase(GET_M_User_SelectAPI.rejected, (state, action) => {
            console.log("Error", action.error?.message);
            state.isLoading = false;
            state.isError = true;
            state.TableData = null;
        });
    },
})

export const GET_M_User_SelectReducer = GET_M_User_SelectSlice.reducer